module.exports = "/_next/static/images/c9a82fc21f53be97bf8d1212c7c27226-slide-1.png.webp";